export enum MxColumnType {
  Id = 0,
  Text = 10,
  Number = 20,
  Boolean = 30,
  Enum = 40,
  Date = 50,
  DateTime = 60,
  RemoteSource = 70,
  Link = 80,
}
